module.exports = __webpack_public_path__ + "front/img/p17.4768818e.png";